export const isNullOrEmptyString = (valor) => {
  return valor === null || valor === '';
};
